const MATRIZ_ID = 1

const SEGMENTO_INDUSTRIA = 1
const SEGMENTO_COMERCIO = 2
const SEGMENTO_SERVICO = 3

const DESCRICAO_SEGMENTOS = {
  [SEGMENTO_INDUSTRIA]: 'Indústria',
  [SEGMENTO_COMERCIO]: 'Comércio',
  [SEGMENTO_SERVICO]: 'Serviço',
}

const EXIBIR_VALORES_ESTOQUE = 1
const EXIBIR_STATUS_ESTOQUE = 2

const DESCRICAO_ESTOQUE = {
  [EXIBIR_VALORES_ESTOQUE]: 'Exibir Valores',
  [EXIBIR_STATUS_ESTOQUE]: 'Exibir Status',
}

const SUB_SEGMENTO_TECNOLOGIA = 1
const SUB_SEGMENTO_MANUTENCAO_VEICULAR = 2
const SUB_SEGMENTO_CONSULTORIA = 3
const SUB_SEGMENTO_SAUDE = 4
const SUB_SEGMENTO_EDUCACAO = 5
const SUB_SEGMENTO_MARKETING = 6
const SUB_SEGMENTO_LOGISTICA = 7
const SUB_SEGMENTO_CONSTRUCAO_CIVIL = 8
const SUB_SEGMENTO_FINANCEIRO = 9
const SUB_SEGMENTO_JURIDICO = 10
const SUB_SEGMENTO_TURISMO = 11
const SUB_SEGMENTO_ALIMENTACAO = 12

const DESCRICAO_SUBSEGMENTOS = {
  [SEGMENTO_INDUSTRIA]: {
    [SUB_SEGMENTO_TECNOLOGIA]: 'Tecnologia Industrial',
    [SUB_SEGMENTO_CONSTRUCAO_CIVIL]: 'Construção Civil',
    [SUB_SEGMENTO_ALIMENTACAO]: 'Indústria Alimentícia',
  },
  [SEGMENTO_COMERCIO]: {
    [SUB_SEGMENTO_TECNOLOGIA]: 'Comércio de Tecnologia',
    [SUB_SEGMENTO_ALIMENTACAO]: 'Comércio Alimentício',
    [SUB_SEGMENTO_FINANCEIRO]: 'Serviços Financeiros',
  },
  [SEGMENTO_SERVICO]: {
    [SUB_SEGMENTO_TECNOLOGIA]: 'Tecnologia',
    [SUB_SEGMENTO_MANUTENCAO_VEICULAR]: 'Manutenção Veicular',
    [SUB_SEGMENTO_CONSULTORIA]: 'Consultoria',
    [SUB_SEGMENTO_SAUDE]: 'Saúde',
    [SUB_SEGMENTO_EDUCACAO]: 'Educação',
    [SUB_SEGMENTO_MARKETING]: 'Marketing e Publicidade',
    [SUB_SEGMENTO_LOGISTICA]: 'Logística',
    [SUB_SEGMENTO_JURIDICO]: 'Serviços Jurídicos',
    [SUB_SEGMENTO_TURISMO]: 'Turismo e Hotelaria',
  },
}

const RECEITA_AO_FATURAR = 1
const RECEITA_APOS_EMISSAO_FISCAL = 2
const RECEITA_AO_APROVAR = 3

const DESCRICAO_CONFIGURACAO_RECEITA = {
  [RECEITA_AO_FATURAR]: 'Ao faturar venda',
  [RECEITA_APOS_EMISSAO_FISCAL]: 'Ao emitir documento fiscal',
  [RECEITA_AO_APROVAR]: 'Ao aprovar venda (status Aprovado)',
}

const ESTOQUE_AO_FATURAR = 1
const ESTOQUE_APOS_EMISSAO_FISCAL = 2
const ESTOQUE_AO_APROVAR = 3

const DESCRICAO_CONFIGURACAO_ESTOQUE = {
  [ESTOQUE_AO_FATURAR]: 'Ao faturar venda',
  [ESTOQUE_APOS_EMISSAO_FISCAL]: 'Ao emitir documento fiscal',
  [ESTOQUE_AO_APROVAR]: 'Ao aprovar venda (status Aprovado)',
}

export {
  MATRIZ_ID,

  SEGMENTO_INDUSTRIA,
  SEGMENTO_COMERCIO,
  SEGMENTO_SERVICO,
  DESCRICAO_SEGMENTOS,
  DESCRICAO_SUBSEGMENTOS,

  EXIBIR_VALORES_ESTOQUE,
  EXIBIR_STATUS_ESTOQUE,
  DESCRICAO_ESTOQUE,

  RECEITA_AO_FATURAR,
  RECEITA_APOS_EMISSAO_FISCAL,
  RECEITA_AO_APROVAR,

  ESTOQUE_AO_FATURAR,
  ESTOQUE_APOS_EMISSAO_FISCAL,
  ESTOQUE_AO_APROVAR,

  DESCRICAO_CONFIGURACAO_RECEITA,
  DESCRICAO_CONFIGURACAO_ESTOQUE,

  SUB_SEGMENTO_TECNOLOGIA,
  SUB_SEGMENTO_MANUTENCAO_VEICULAR,
  SUB_SEGMENTO_CONSULTORIA,
  SUB_SEGMENTO_SAUDE,
  SUB_SEGMENTO_EDUCACAO,
  SUB_SEGMENTO_MARKETING,
  SUB_SEGMENTO_LOGISTICA,
  SUB_SEGMENTO_CONSTRUCAO_CIVIL,
  SUB_SEGMENTO_FINANCEIRO,
  SUB_SEGMENTO_JURIDICO,
  SUB_SEGMENTO_TURISMO,
  SUB_SEGMENTO_ALIMENTACAO,
}
